import React from 'react';
type Props = {
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
  disabled?: boolean;
};
// Single numeric field for SKR codes. Receipts are issued with codes of
// different lengths (7–11 digits), so one field fits them all.
export function CodeInput({
  value,
  onChange,
  maxLength = 11,
  disabled
}: Props) {
  return <input type="text" inputMode="numeric" autoComplete="off" aria-label="SKR code" placeholder="Enter code" value={value} disabled={disabled} maxLength={maxLength} onChange={e => onChange(e.target.value.replace(/\D/g, '').slice(0, maxLength))} className="h-16 w-full rounded-xl border border-steca-200 bg-white px-4 text-center font-display text-2xl font-bold tracking-[0.3em] text-steca-ink outline-none transition-colors placeholder:text-base placeholder:font-medium placeholder:tracking-normal placeholder:text-steca-ink/40 focus:border-steca-500 focus:ring-2 focus:ring-steca-200 disabled:bg-slate-50 sm:text-3xl" data-id="element-14" data-mp="2chabu0fpvd47" />;
}